import { AdvanceConsumerReportPermissionScreen } from '@varo/graphql-schema-types';
import FetchAdvanceConsumerReportPermission from 'services/graphql/queries/advance/FetchAdvanceConsumerReportPermissions';
import { RequestPolicy, useQuery } from 'urql';

export interface AdvanceConsumerReportsScreen {
  advanceConsumerReportPermissionScreen: AdvanceConsumerReportPermissionScreen;
}

interface UseGetConsumerReportsAccountParams {
  pause?: boolean;
  requestPolicy?: RequestPolicy;
}

const useGetConsumerReportsAccount = ({
  pause = false,
  requestPolicy = 'cache-and-network',
}: UseGetConsumerReportsAccountParams) => {
  const [{ data, error, fetching }, refetch] =
    useQuery<AdvanceConsumerReportsScreen>({
      query: FetchAdvanceConsumerReportPermission,
      pause,
      requestPolicy,
    });

  const { advanceConsumerReportPermissionScreen } = data || {};

  return {
    data: advanceConsumerReportPermissionScreen,
    fetching,
    error,
    refetch,
  };
};

export default useGetConsumerReportsAccount;
